// extracted by mini-css-extract-plugin
var _1 = "ListFormValueItem_actions__95f1f";
var _2 = "ListFormValueItem_active__25cf6";
var _3 = "ListFormValueItem_header__bca60";
var _4 = "ListFormValueItem_point__f77f7";
var _5 = "ListFormValueItem_root__bf70b";
var _6 = "ListFormValueItem_title__0131e";
export { _1 as "actions", _2 as "active", _3 as "header", _4 as "point", _5 as "root", _6 as "title" }
